import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const InvoicePreview = ({ data }) => {
  const invoiceRef = useRef();

  const downloadPDF = async () => {
    const canvas = await html2canvas(invoiceRef.current);
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "pt", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(`Invoice_${data.invoice.razorpay_invoice_id}.pdf`);
  };

  const { user, invoice, payment } = data;

  return (
    <div>
      <div className="invoice-container" ref={invoiceRef} style={{ padding: 30, fontFamily: 'Arial, sans-serif', background: "#fff", color: "#000", maxWidth: 800, margin: "auto", border: "1px solid #ddd" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 40 }}>
          <div>
            <h2>Invoice</h2>
            <p>Invoice Number #{invoice.razorpay_invoice_id}</p>
          </div>
          <img src="/logo.svg" alt="logo" height={50} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
          <div>
            <h4>Billed By</h4>
            <p>Yooki EdTech Pvt. Ltd.<br />Bhubaneswar, India<br />support@yooki.app</p>
          </div>
          <div>
            <h4>Billed To</h4>
            <p>
              {user.first_name} {user.last_name}<br />
              {user.email}<br />
              {user.phone_number || ""}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 30 }}>
          <p><strong>Date Issued:</strong> {new Date(invoice.created_at).toLocaleDateString()}</p>
          <p><strong>Due Date:</strong> {new Date(invoice.created_at).toLocaleDateString()}</p>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
          <thead>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={{ padding: 10, border: "1px solid #ccc" }}>Item/Service</th>
              <th style={{ padding: 10, border: "1px solid #ccc" }}>Qty</th>
              <th style={{ padding: 10, border: "1px solid #ccc" }}>Unit Price</th>
              <th style={{ padding: 10, border: "1px solid #ccc" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: 10, border: "1px solid #ccc" }}>Yooki Pro Subscription</td>
              <td style={{ padding: 10, border: "1px solid #ccc" }}>1</td>
              <td style={{ padding: 10, border: "1px solid #ccc" }}>₹{invoice.amount}</td>
              <td style={{ padding: 10, border: "1px solid #ccc" }}>₹{invoice.amount}</td>
            </tr>
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <div style={{ width: 250 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span>Subtotal</span><span>₹{invoice.amount}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span>Tax (0%)</span><span>₹0</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
              <span>Total</span><span>₹{invoice.amount}</span>
            </div>
          </div>
        </div>

        <p style={{ marginTop: 20, fontSize: 10, color: "#888" }}>
          Notes: Payment is auto-confirmed. This is a system-generated invoice.
        </p>
      </div>

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button onClick={downloadPDF} style={{ padding: "10px 20px", background: "#007bff", color: "#fff", border: "none", borderRadius: 5 }}>
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default InvoicePreview;
